const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_API_VERSION}`;

const DETALLE_INSCRIPCION_URL=`${API_BASE_URL}/Sorteo/GetEstadoInscripcionAsync`;

export {
    DETALLE_INSCRIPCION_URL
};